module.exports = "/dist/montserrat-latin-200italic.svg?3a2afc11ae52e436e28f82d7c169db45";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-200italic.svg
// module id = 69
// module chunks = 0